/** Punjabi (Gurmukhi) UI strings (merged over English in translations.js). */
export const rawPa = {
  nav: {
    home: "ਮੁੱਖ ਪੰਨਾ",
    database: "ਠੱਗਾਂ ਦਾ ਡੇਟਾਬੇਸ",
    recovery: "ਰਿਕਵਰੀ ਪ੍ਰਕਿਰਿਆ",
    risk: "ਜੋਖਮ ਜਾਂਚ",
    redFlags: "ਲਾਲ ਝੰਡੇ",
    education: "ਜਾਗਰੂਕਤਾ",
    stories: "ਅਸਲ ਕਹਾਣੀਆਂ",
    about: "ਸਾਡੇ ਬਾਰੇ",
    contact: "ਸੰਪਰਕ",
    legalHelp: "ਕਾਨੂੰਨੀ ਮਦਦ",
    reportCta: "ਨੁਕਸਾਨ ਦੀ ਰਿਪੋਰਟ",
    mentors: "ਮੈਂਟਰ",
    dashboard: "ਡੈਸ਼ਬੋਰਡ",
    signIn: "ਸਾਈਨ ਇਨ",
    signOut: "ਸਾਈਨ ਆਉਟ",
  },
  common: {
    reportScam: "ਨੁਕਸਾਨ ਦੀ ਰਿਪੋਰਟ",
    learnRecovery: "ਸ਼ਿਕਾਇਤ ਪ੍ਰਕਿਰਿਆ ਜਾਣੋ",
    confidential: "100% ਗੁਪਤ",
    readMore: "ਹੋਰ ਪੜ੍ਹੋ",
    backHome: "ਮੁੱਖ ਪੰਨੇ 'ਤੇ ਵਾਪਸ",
    search: "ਖੋਜੋ",
    verified: "ਪ੍ਰਮਾਣਿਤ",
    anonymous: "ਗੁਮਨਾਮ",
    submit: "ਜਮ੍ਹਾਂ ਕਰੋ",
    cancel: "ਰੱਦ",
    requiredField: "ਲਾਜ਼ਮੀ",
    check: "ਹੁਣੇ ਜਾਂਚੋ",
    loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ…",
    error: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  },
  hero: {
    eyebrow: "ਭਾਰਤ ਦਾ ਸਬੂਤ-ਅਧਾਰਿਤ ਵਿੱਤੀ ਸ਼ਿਕਾਇਤ ਮਾਰਗਦਰਸ਼ਨ",
    title1: "ਵਿੱਤੀ ਨੁਕਸਾਨ ਦੇ",
    title2: "ਖਿਲਾਫ ਲੜੋ।",
    subtitle:
      "ਟ੍ਰੇਡਿੰਗ ਧੋਖਾਧੜੀ ਤੋਂ ਬੈਂਕਿੰਗ, ਸਾਈਬਰ, ਬੀਮਾ, ਏਅਰਲਾਈਨ, ਗਾਹਕ, ਹਾਊਸਿੰਗ ਫਾਈਨੈਂਸ ਅਤੇ ਪੈਨਸ਼ਨ ਵਿਵਾਦਾਂ ਤੱਕ — ਸਹੀ ਅਥਾਰਟੀ, ਸਹੀ ਸਬੂਤ ਅਤੇ ਅਧਿਕਾਰਤ ਭਾਰਤੀ ਸ਼ਿਕਾਇਤ ਸਿਸਟਮ ਵਿੱਚ ਸਹੀ ਅਗਲਾ ਕਦਮ।",
    reportBtn: "ਵਿੱਤੀ ਨੁਕਸਾਨ ਦੀ ਰਿਪੋਰਟ ਕਰੋ",
    recoveryBtn: "ਸ਼ਿਕਾਇਤ ਪ੍ਰਕਿਰਿਆ ਜਾਣੋ",
    taglines: ["ਸਹੀ ਅਥਾਰਟੀ ਲੱਭੋ।", "ਸਹੀ ਸਬੂਤ ਤਿਆਰ ਕਰੋ।", "ਸਹੀ ਕਦਮ ਚੁੱਕੋ।"],
  },
  report: {
    title: "ਗੁਮਨਾਮ ਰਿਪੋਰਟ ਕਰੋ",
    subtitle: "ਤੁਹਾਡੀ ਪਛਾਣ ਪੂਰੀ ਤਰ੍ਹਾਂ ਗੁਪਤ ਰਹੇਗੀ। ਪ੍ਰਕਾਸ਼ਨ ਤੋਂ ਪਹਿਲਾਂ ਹਰ ਰਿਪੋਰਟ ਦੀ ਜਾਂਚ ਹੋਵੇਗੀ।",
    scamType: "ਨੁਕਸਾਨ ਦੀ ਕਿਸਮ",
    amountLost: "ਨੁਕਸਾਨ ਦੀ ਰਕਮ (₹)",
    platform: "ਵਰਤਿਆ ਪਲੇਟਫਾਰਮ",
    telegram: "ਟੈਲੀਗ੍ਰਾਮ ਯੂਜ਼ਰਨੇਮ (ਜੇ ਹੋਵੇ)",
    upi: "UPI ID (ਜੇ ਹੋਵੇ)",
    phone: "ਫੋਨ ਨੰਬਰ (ਜੇ ਹੋਵੇ)",
    company: "ਕੰਪਨੀ / ਸਲਾਹਕਾਰ ਦਾ ਨਾਮ",
    website: "ਵੈੱਬਸਾਈਟ URL",
    description: "ਕੀ ਹੋਇਆ — ਵਿਸਥਾਰ ਨਾਲ ਲਿਖੋ",
    contact: "ਈਮੇਲ (ਵਿਕਲਪਿਕ)",
    uploadEvidence: "ਸਬੂਤ ਅਪਲੋਡ",
    uploadHelp: "ਸਕ੍ਰੀਨਸ਼ਾਟ, PDF, ਭੁਗਤਾਨ ਸਬੂਤ, ਚੈਟ ਐਕਸਪੋਰਟ। ਫਾਈਲ ਲਈ 10MB।",
    submit: "ਸੁਰੱਖਿਅਤ ਤਰੀਕੇ ਨਾਲ ਜਮ੍ਹਾਂ ਕਰੋ",
    successTitle: "ਰਿਪੋਰਟ ਜਮ੍ਹਾਂ",
    successDesc: "ਧੰਨਵਾਦ। 72 ਘੰਟਿਆਂ ਵਿੱਚ ਸਾਡੀ ਟੀਮ ਸਬੂਤ ਦੀ ਜਾਂਚ ਕਰੇਗੀ। ਤੁਹਾਡੀ ਪਛਾਣ ਗੁਪਤ ਰਹੇਗੀ।",
    disclaimer: "ਹਰ ਦੋਸ਼ ਲਈ ਸਬੂਤ ਲਾਜ਼ਮੀ ਹੈ। ਝੂਠੀਆਂ ਰਿਪੋਰਟਾਂ ਰੱਦ ਹੋ ਸਕਦੀਆਂ ਹਨ।",
  },
  education: {
    eyebrow: "ਸਿੱਖੋ · ਬਚਾਓ · ਰਿਕਵਰ",
    title: "ਜਾਗਰੂਕਤਾ ਕੇਂਦਰ",
    subtitle: "ਭਾਰਤੀ ਨਿਵੇਸ਼ਕਾਂ ਲਈ ਧੋਖਾਧੜੀ ਜਾਗਰੂਕਤਾ ਅਤੇ ਕਾਨੂੰਨੀ ਮਾਰਗਦਰਸ਼ਨ।",
    readMinutes: "ਮਿੰਟ ਪੜ੍ਹਨਾ",
    filterAll: "ਸਾਰੇ",
    emptyCategory: "ਇਸ ਸ਼੍ਰੇਣੀ ਵਿੱਚ ਅਜੇ ਲੇਖ ਨਹੀਂ।",
  },
  blog: {
    eyebrow: "ਜਾਂਚ · ਕਹਾਣੀਆਂ · ਗਾਈਡ",
    title: "ਬਲੌਗ — ਅਸਲ ਕੇਸ, ਕਾਨੂੰਨੀ ਮਾਰਗ",
    subtitle: "ਪ੍ਰਮਾਣਿਤ ਪੀੜਤ ਅਨੁਭਵ ਅਤੇ ਕਾਨੂੰਨੀ ਸ਼ਿਕਾਇਤ ਕਦਮ।",
    allStories: "ਸਾਰੀਆਂ ਕਹਾਣੀਆਂ",
    featured: "ਵਿਸ਼ੇਸ਼",
    readFull: "ਪੂਰਾ ਪੜ੍ਹੋ",
    readArticle: "ਪੂਰਾ ਲੇਖ",
    collapse: "ਸਮੇਟੋ",
    emptyCategory: "ਇਸ ਸ਼੍ਰੇਣੀ ਵਿੱਚ ਅਜੇ ਲੇਖ ਨਹੀਂ।",
    newBadge: "ਨਵਾਂ",
  },
  footer: {
    tagline: "ਸੁਣੀ-ਸੁਣਾਈ ਨਹੀਂ, ਸਬੂਤ। ਚੁੱਪੀ ਨਹੀਂ, ਸੁਰੱਖਿਆ।",
    sections: { platform: "ਪਲੇਟਫਾਰਮ", legal: "ਕਾਨੂੰਨੀ", connect: "ਜੁੜੋ" },
    links: {
      privacy: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
      terms: "ਵਰਤੋਂ ਦੀਆਂ ਸ਼ਰਤਾਂ",
      disclaimer: "ਬੇਦਾਅਵਾ",
      antiHarassment: "ਪੀੜਨ-ਵਿਰੋਧੀ ਨੀਤੀ",
      dataDeletion: "ਡੇਟਾ ਮਿਟਾਉਣ ਦੀ ਬੇਨਤੀ",
    },
    disclaimer: "CHINTAMAT ਵਿੱਤੀ ਸਲਾਹ ਨਹੀਂ ਦਿੰਦਾ। ਰਿਕਵਰੀ ਦੀ ਗਾਰੰਟੀ ਨਹੀਂ।",
    rights: "© 2026 CHINTAMAT. ਜਨ-ਹਿਤ ਐਂਟੀ-ਸਕੈਮ ਮਿਸ਼ਨ।",
  },
  stats: {
    reports: "ਪ੍ਰਮਾਣਿਤ ਸ਼ਿਕਾਇਤਾਂ",
    scammers: "ਟ੍ਰੈਕ ਕੀਤੇ ਠੱਗ",
    cases: "ਹੱਲ ਕੀਤੇ ਕੇਸ",
    loss: "ਰਿਪੋਰਟ ਕੀਤਾ ਨੁਕਸਾਨ",
  },
};

export const appStringsPa = {
  lang: { choose: "ਭਾਸ਼ਾ ਚੁਣੋ" },
  auth: {
    welcomeBack: "ਦੁਬਾਰਾ ਸਵਾਗਤ",
    signInSubtitle: "ਰਿਵਿਊ, ਕੇਸ ਟ੍ਰੈਕ ਅਤੇ ਮੈਂਟਰ ਸੇਵ ਕਰਨ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ।",
    joinTitle: "CHINTAMAT ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ",
    joinSubtitle: "ਸਕੈਮ ਰਿਪੋਰਟ, ਕਾਨੂੰਨੀ ਮਦਦ ਅਤੇ ਮੈਂਟਰ ਡਾਇਰੈਕਟਰੀ ਲਈ ਖਾਤਾ ਬਣਾਓ।",
    email: "ਈਮੇਲ",
    password: "ਪਾਸਵਰਡ",
    name: "ਪੂਰਾ ਨਾਮ",
    signIn: "ਸਾਈਨ ਇਨ",
    signUp: "ਖਾਤਾ ਬਣਾਓ",
    continueGoogle: "Google ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
    orEmail: "ਜਾਂ ਈਮੇਲ",
    newHere: "CHINTAMAT 'ਤੇ ਨਵੇਂ?",
    haveAccount: "ਪਹਿਲਾਂ ਤੋਂ ਖਾਤਾ ਹੈ?",
    createAccount: "ਖਾਤਾ ਬਣਾਓ",
    gotoSignIn: "ਸਾਈਨ ਇਨ",
    passwordMin: "ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰ",
    roleUser: "ਵਿਅਕਤੀਗਤ",
    roleUserDesc: "ਟ੍ਰੇਡਰ / ਪੀੜਤ — ਰਿਪੋਰਟ ਜਾਂ ਖੋਜ ਲਈ।",
    roleMentor: "ਮੈਂਟਰ / ਅਧਿਆਪਕ",
    roleMentorDesc: "ਕੋਰਸ, ਚੈਨਲ ਜਾਂ paid mentorship ਚਲਾਉਂਦਾ/ਦੀ।",
    roleAdvisory: "ਖੋਜ ਵਿਸ਼ਲੇਸ਼ਕ / ਸਲਾਹਕਾਰ",
    roleAdvisoryDesc: "SEBI-ਰਜਿਸਟਰਡ RIA, RA ਜਾਂ ਫirm।",
    verifying: "ਸੈਸ਼ਨ ਜਾਂਚ…",
    adminRequired: "ਐਡਮਿਨ ਪਹੁੰਚ ਲੋੜੀਂ।",
  },
  dashboard: {
    eyebrow: "\u0A2E\u0A47\u0A30\u0A3E \u0A21\u0A48\u0A38\u0A3C\u0A2C\u0A4B\u0A30\u0A21\u0A3C",
    hello: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ",
    adminPanel: "ਐਡਮਿਨ ਪੈਨਲ",
    adminDesc: "ਯੂਜ਼ਰ, ਸਕੈਮ ਰਿਪੋਰਟ, ਕਾਨੂੰਨੀ ਮਦਦ ਅਤੇ ਬਲੌਗ ਪ੍ਰਬੰਧਿਤ ਕਰੋ।",
    openAdmin: "ਐਡਮਿਨ ਖੋਲ੍ਹੋ",
    statReviews: "ਲਿਖੇ ਰਿਵਿਊ",
    statCases: "ਰਿਪੋਰਟ ਕੀਤੇ ਕੇਸ",
    statLegal: "ਕਾਨੂੰਨੀ ਬੇਨਤੀਆਂ",
    statSaved: "ਸੇਵ ਕੀਤੇ ਮੈਂਟਰ",
    tabReviews: "\u0A2E\u0A47\u0A30\u0A47 \u0A30\u0A3F\u0A35\u0A3F\u0A09",
    tabCases: "\u0A2E\u0A47\u0A30\u0A47 \u0A15\u0A47\u0A38",
    tabSaved: "ਸੇਵ ਮੈਂਟਰ",
    tabLegal: "ਕਾਨੂੰਨੀ ਮਦਦ",
    emptyReviews: "ਅਜੇ ਰਿਵਿਊ ਨਹੀਂ।",
    browseMentors: "ਮੈਂਟਰ ਦੇਖੋ",
    emptyCases: "ਅਜੇ ਕੇਸ ਨਹੀਂ।",
    reportScam: "ਨੁਕਸਾਨ ਰਿਪੋਰਟ",
    emptySaved: "ਸੇਵ ਮੈਂਟਰ ਨਹੀਂ।",
    discoverMentors: "ਮੈਂਟਰ ਲੱਭੋ",
    emptyLegal: "ਅਜੇ ਕਾਨੂੰਨੀ ਬੇਨਤੀਆਂ ਨਹੀਂ।",
    submitLegal: "ਬੇਨਤੀ ਭੇਜੋ",
    viewProfile: "ਪ੍ਰੋਫਾਈਲ",
    recentActivity: "ਤਾਜ਼ਾ ਅਪਡੇਟ",
    openCase: "ਕੇਸ ਖੋਲ੍ਹੋ",
    prefsTitle: "ਸੂਚਨਾ ਤਰਜੀਹਾਂ",
    prefsBlog: "ਨਵੇਂ ਬਲੌਗ ਅਤੇ ਜਾਗਰੂਕਤਾ ਲੇਖ",
    prefsCase: "ਕੇਸ ਸਥਿਤੀ ਅਤੇ ਸਟਾਫ ਜਵਾਬ",
    prefsSaved: "ਤਰਜੀਹਾਂ ਸੇਵ",
  },
  notifications: {
    title: "ਸੂਚਨਾਵਾਂ",
    empty: "ਅਜੇ ਸੂਚਨਾਵਾਂ ਨਹੀਂ",
    markAllRead: "ਸਾਰੀਆਂ ਪੜ੍ਹੀਆਂ ਮਾਰਕ ਕਰੋ",
    viewDashboard: "ਡੈਸ਼ਬੋਰਡ ਖੋਲ੍ਹੋ",
    types: {
      case_status_change: { title: "{caseLabel} — ਸਥਿਤੀ ਅਪਡੇਟ", body: "ਤੁਹਾਡਾ ਕੇਸ ਹੁਣ: {status}" },
      case_staff_comment: { title: "CHINTAMAT ਤੋਂ ਜਵਾਬ", body: "{authorName}: {preview}" },
      case_user_comment: { title: "ਯੂਜ਼ਰ ਟਿੱਪਣੀ — {caseLabel}", body: "{authorName}: {preview}" },
      new_scam_report: { title: "ਨਵੀਂ ਸਕੈਮ ਰਿਪੋਰਟ", body: "{scamType}" },
      new_legal_request: { title: "ਨਵੀਂ ਕਾਨੂੰਨੀ ਬੇਨਤੀ", body: "{lossType} — {name}" },
      blog_published: { title: "ਨਵਾਂ ਲੇਖ", body: "{articleTitle}" },
    },
  },
  caseWorkspace: {
    evidenceTitle: "ਸਬੂਤ ਚੈਕਲਿਸਟ",
    statusTimeline: "ਸਥਿਤੀ ਟਾਈਮਲਾਈਨ",
    comments: "ਟਿੱਪਣੀਆਂ",
    sendMessage: "ਸੁਨੇਹਾ ਭੇਜੋ",
    postComment: "ਟਿੱਪਣੀ ਪੋਸਟ",
    noComments: "ਅਜੇ ਟਿੱਪਣੀਆਂ ਨਹੀਂ। CHINTAMAT ਸਟਾਫ ਇੱਥੇ ਜਵਾਬ ਦੇਵੇਗਾ।",
    userCommentHint: "ਤੁਹਾਡਾ ਸੁਨੇਹਾ CHINTAMAT ਸਟਾਫ ਨੂੰ ਦਿਖੇਗਾ।",
    staffCommentHint: "ਜਨਤਕ ਟਿੱਪਣੀਆਂ ਯੂਜ਼ਰ ਨੂੰ ਦਿਖਦੀਆਂ ਹਨ। ਅੰਦਰੂਨੀ ਨੋਟ ਸਿਰਫ ਸਟਾਫ ਲਈ।",
    publicVis: "ਜਨਤਕ (ਯੂਜ਼ਰ ਦੇਖ ਸਕਦਾ)",
    internalVis: "ਸਿਰਫ ਅੰਦਰੂਨੀ",
    loading: "ਕੇਸ ਲੋਡ…",
    notFound: "ਕੇਸ ਨਹੀਂ ਮਿਲਿਆ",
    caseUpdated: "ਕੇਸ ਅਪਡੇਟ",
    commentPosted: "ਟਿੱਪਣੀ ਪੋਸਟ",
    checklist: {
      screenshots: "ਚੈਟ ਜਾਂ ਸਕ੍ਰੀਨਸ਼ਾਟ ਸਬੂਤ",
      payment_proof: "UPI / ਬੈਂਕ ਭੁਗਤਾਨ ਸਬੂਤ",
      platform_profile: "ਠੱਗ ਪ੍ਰੋਫਾਈਲ ਲਿੰਕ",
      contract: "ਇਨਵੌਇਸ ਜਾਂ ਸਮਝੌਤਾ",
    },
  },
  mentors: {
    title: "ਮੈਂਟਰ ਡਾਇਰੈਕਟਰੀ",
    subtitle: "ਭੁਗਤਾਨ ਤੋਂ ਪਹਿਲਾਂ ਮੈਂਟਰ ਜਾਂਚੋ। ਰਿਵਿਊ ਰਜਿਸਟਰਡ ਯੂਜ਼ਰਾਂ ਤੋਂ — SEBI ਰਜਿਸਟ੍ਰੇਸ਼ਨ independently verify ਕਰੋ।",
    search: "ਨਾਮ, ਕੰਪਨੀ, ਸ਼ਹਿਰ ਖੋਜੋ…",
    category: "ਸ਼੍ਰੇਣੀ",
    allCategories: "ਸਾਰੀਆਂ ਸ਼੍ਰੇਣੀਆਂ",
    verification: "ਪ੍ਰਮਾਣੀਕਰਨ",
    all: "ਸਾਰੇ",
    verifiedOnly: "ਸਿਰਫ ਪ੍ਰਮਾਣਿਤ",
    unverified: "ਅਪ੍ਰਮਾਣਿਤ",
    sortTrust: "ਸਭ ਤੋਂ ਵੱਧ ਭਰੋਸਾ",
    sortReviews: "ਸਭ ਤੋਂ ਵੱਧ ਰਿਵਿਊ",
    sortRecent: "ਤਾਜ਼ਾ",
    noResults: "ਮੈਂਟਰ ਨਹੀਂ ਮਿਲੇ।",
    viewProfile: "ਪ੍ਰੋਫਾਈਲ",
    reviews: "ਰਿਵਿਊ",
  },
  protected: { loading: "ਸੈਸ਼ਨ ਜਾਂਚ…", adminLoading: "ਐਡਮਿਨ ਜਾਂਚ…" },
};
